module.exports = __webpack_public_path__ + "img/frogs.64a068db.png";